import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Construction } from 'lucide-react';

const ComingSoonTab = ({ title, description, features }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Construction className="w-16 h-16 text-purple-600 mb-4" />
      <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 text-center max-w-md mb-6">{description}</p>
      
      <Card className="w-full max-w-2xl">
        <CardContent className="pt-6">
          <h4 className="font-semibold mb-3">Planned Features:</h4>
          <ul className="space-y-2">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-purple-600">•</span>
                <span className="text-sm text-gray-700">{feature}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoonTab;
